import styled from '@emotion/styled';

export const DayPickerContainer = styled.div`
  width: 100%;
  .DayPicker.BookingCalendar {
    width: 100%;
    .DayPicker-wrapper {
      display: flex;
      flex-direction: column;
      .DayPicker-NavBar {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        span.DayPicker-NavButton {
          position: initial;
        }
      }

      .DayPicker-Months {
        justify-content: space-around;
        gap: 16px;
        .DayPicker-Month {
          display: initial;
          margin: 0;

          .DayPicker-Weekdays {
            display: flex;
            flex-direction: row;
            margin-top: 0;
            .DayPicker-WeekdaysRow {
              display: flex;
              flex-direction: row;
              width: 100%;
              .DayPicker-Weekday {
                width: 100%;
              }
            }
          }
          .DayPicker-Caption {
            display: flex;
            border-bottom: 1px solid var(--chakra-colors-gray-200);
          }

          .DayPicker-Body {
            display: flex;
            flex-direction: column;
            .DayPicker-Week {
              display: flex;
              flex-direction: row;
              .DayPicker-Day {
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 0;
                margin: 2px;
                height: var(--chakra-sizes-10);
                width: var(--chakra-sizes-10);
                border-radius: 4px;
                border: 1px solid var(--chakra-colors-gray-200);
                color: var(--chakra-colors-green-500);
                font-weight: 600;
                cursor: pointer;
                background: none;

                &.DayPicker-Day.DayPicker-Day--bookedUp.DayPicker-Day--minNightsNotReached.DayPicker-Day--bookedUpArrivalDay.DayPicker-Day--bookedUpDepartureDay.DayPicker-Day--outside,
                &.DayPicker-Day.DayPicker-Day--bookedUp.DayPicker-Day--bookedUpArrivalDay.DayPicker-Day--outside,
                &.DayPicker-Day--bookedUp.DayPicker-Day--minNightsNotReached.DayPicker-Day--bookedUpArrivalDay.DayPicker-Day--outside,
                &.DayPicker-Day--bookedUp.DayPicker-Day--bookedUpArrivalDay.DayPicker-Day--bookedUpDepartureDay.DayPicker-Day--outside,
                &.DayPicker-Day--bookedUp.DayPicker-Day--bookedUpDepartureDay.DayPicker-Day--potentialArrivalDay.DayPicker-Day--outside,
                &.DayPicker-Day--bookedUp.DayPicker-Day--bookedUpDepartureDay.DayPicker-Day--disabled,
                &.DayPicker-Day--start.DayPicker-Day--bookedUp.DayPicker-Day--bookedUpDepartureDay.DayPicker-Day--selected.DayPicker-Day--outside,
                &.DayPicker-Day--bookedUp.DayPicker-Day--bookedUpDepartureDay.DayPicker-Day--outside,
                &.DayPicker-Day--potentialDepartureDay.DayPicker-Day--outside,
                &.DayPicker-Day--start.DayPicker-Day--selected.DayPicker-Day--outside,
                &.DayPicker-Day--end.DayPicker-Day--selected.DayPicker-Day--outside,
                &.DayPicker-Day--bookedUp.DayPicker-Day--disabled.DayPicker-Day--outside,
                &.DayPicker-Day--minNightsNotReached.DayPicker-Day--outside,
                &.DayPicker-Day--selected.DayPicker-Day--outside,
                &.DayPicker-Day--potentialDepartureDay.DayPicker-Day--disabled,
                &.DayPicker-Day--potentialArrivalDay.DayPicker-Day--outside,
                &.DayPicker-Day--disabled,
                &.DayPicker-Day--outside {
                  border: none;
                  color: var(--chakra-colors-gray-300);
                  background: none var(--chakra-colors-gray-50);
                  cursor: not-allowed;
                  font-weight: normal;
                  &:hover {
                    background: none var(--chakra-colors-gray-50);
                  }
                }

                &.DayPicker-Day--potentialArrivalDay,
                &.DayPicker-Day--potentialDepartureDay {
                  border: 1px solid var(--chakra-colors-green-500);
                  cursor: pointer;
                  :hover {
                    background: none var(--chakra-colors-green-50);
                  }
                }

                &.DayPicker-Day--bookedUp.DayPicker-Day--bookedUpDepartureDay.DayPicker-Day--potentialArrivalDay {
                  border: 1px solid var(--chakra-colors-green-500);
                  color: var(--chakra-colors-green-500);
                  cursor: pointer;
                  &:hover {
                    background: linear-gradient(
                      -135deg,
                      var(--chakra-colors-green-50) 50%,
                      var(--chakra-colors-red-400) 50%
                    );
                  }
                }

                &.DayPicker-Day--bookedUp.DayPicker-Day--bookedUpArrivalDay.DayPicker-Day--potentialDepartureDay {
                  border: 1px solid var(--chakra-colors-green-500);
                  color: var(--chakra-colors-green-500);
                  cursor: pointer;
                  text-decoration: inherit;
                  :hover {
                    background: linear-gradient(
                      135deg,
                      var(--chakra-colors-green-50) 50%,
                      var(--chakra-colors-red-400) 50%
                    );
                  }
                }

                &.DayPicker-Day--bookedUp.DayPicker-Day--bookedUpArrivalDay.DayPicker-Day--bookedUpDepartureDay,
                &.DayPicker-Day--bookedUp.DayPicker-Day--disabled {
                  background: none var(--chakra-colors-red-400);
                  color: white;
                  cursor: not-allowed;
                  text-decoration: line-through;
                  &:hover {
                    background: none var(--chakra-colors-red-400);
                  }
                }

                &.DayPicker-Day--bookedUp {
                  border: none;
                  text-decoration: line-through;
                  cursor: not-allowed;
                  color: var(--chakra-colors-gray-50);
                  background-color: var(--chakra-colors-red-400);
                  font-weight: normal;
                }

                &.DayPicker-Day--bookedUp.DayPicker-Day--outside {
                  border: none;
                  color: var(--chakra-colors-gray-300);
                  background-color: var(--chakra-colors-gray-50);
                  cursor: not-allowed;
                  font-weight: normal;
                }

                &.DayPicker-Day--minNightsNotReached {
                  border-color: var(--chakra-colors-gray-200);
                  cursor: not-allowed;
                  &:hover {
                    background: none;
                  }
                }

                &.DayPicker-Day--bookedUp.DayPicker-Day--minNightsNotReached.DayPicker-Day--bookedUpArrivalDay.DayPicker-Day--bookedUpDepartureDay,
                &.DayPicker-Day--bookedUp.DayPicker-Day--minNightsNotReached.DayPicker-Day--bookedUpArrivalDay {
                  border: 1px solid var(--chakra-colors-gray-200);
                  background: linear-gradient(135deg, white 50%, var(--chakra-colors-red-400) 50%);
                  color: var(--chakra-colors-green-500);
                  font-weight: 500;
                  cursor: not-allowed;
                }

                &.DayPicker-Day--bookedUp.DayPicker-Day--minNightsNotReached.DayPicker-Day--bookedUpDepartureDay,
                &.DayPicker-Day--bookedUp.DayPicker-Day--minNightsNotReached.DayPicker-Day--bookedUpArrivalDay {
                  border: 1px solid var(--chakra-colors-gray-200);
                  cursor: not-allowed;
                  text-decoration: line-through;
                  color: var(--chakra-colors-gray-100);
                }

                &.DayPicker-Day--bookedUp.DayPicker-Day--bookedUpArrivalDay {
                  border: 1px solid var(--chakra-colors-gray-200);
                  background: linear-gradient(135deg, white 50%, var(--chakra-colors-red-400) 50%);
                  color: var(--chakra-colors-gray-100);
                  font-weight: 500;
                  text-decoration: line-through;
                  cursor: not-allowed;
                  &:hover {
                    background: linear-gradient(
                      135deg,
                      white 50%,
                      var(--chakra-colors-red-400) 50%
                    );
                  }
                }

                &.DayPicker-Day--bookedUp.DayPicker-Day--bookedUpDepartureDay {
                  border: 1px solid var(--chakra-colors-gray-200);
                  background: linear-gradient(-135deg, white 50%, var(--chakra-colors-red-400) 50%);
                  color: var(--chakra-colors-gray-100);
                  font-weight: 500;
                  text-decoration: inherit;
                  cursor: not-allowed;
                  &:hover {
                    background: linear-gradient(
                      -135deg,
                      white 50%,
                      var(--chakra-colors-red-400) 50%
                    );
                  }
                }

                &.DayPicker-Day--selected {
                  background-color: var(--chakra-colors-green-200);
                  border: none;
                  color: white;
                  cursor: pointer;
                  &:hover {
                    background-color: var(--chakra-colors-green-200);
                  }
                }

                &.DayPicker-Day--start.DayPicker-Day--selected,
                &.DayPicker-Day--end.DayPicker-Day--selected {
                  background-color: var(--chakra-colors-green-400);
                  border: none;
                  color: white;
                }

                &.DayPicker-Day--start.DayPicker-Day--bookedUp.DayPicker-Day--bookedUpDepartureDay.DayPicker-Day--selected {
                  background: linear-gradient(
                    -135deg,
                    var(--chakra-colors-green-400) 50%,
                    var(--chakra-colors-red-400) 50%
                  );
                  &:hover {
                    cursor: pointer;
                  }
                }

                &.DayPicker-Day--end.DayPicker-Day--bookedUp.DayPicker-Day--bookedUpArrivalDay.DayPicker-Day--selected {
                  background: linear-gradient(
                    135deg,
                    var(--chakra-colors-green-400) 50%,
                    var(--chakra-colors-red-400) 50%
                  );
                  &:hover {
                    cursor: pointer;
                  }
                }
                @media (max-width: 440px) {
                  width: 34px;
                }
              }
            }
          }
        }
      }
    }
  };
  .DayPicker.BookingCalendarReadOnly {
    width: 100%;
    .DayPicker-wrapper {
      display: flex;
      flex-direction: column;
      .DayPicker-NavBar {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        span.DayPicker-NavButton {
          position: initial;
        }
      }
      .DayPicker-Months {
        justify-content: space-around;
        gap: 16px;
        .DayPicker-Month {
          display: initial;
          margin: 0;
          .DayPicker-Weekdays {
            display: flex;
            flex-direction: row;
            margin-top: 0;
            .DayPicker-WeekdaysRow {
              display: flex;
              flex-direction: row;
              width: 100%;
              .DayPicker-Weekday {
                width: 100%;
              }
            }
          }
          .DayPicker-Caption {
            display: flex;
            border-bottom: 1px solid var(--chakra-colors-gray-200);
          }
          .DayPicker-Body {
            display: flex;
            flex-direction: column;
            .DayPicker-Week {
              display: flex;
              flex-direction: row;
              .DayPicker-Day {
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 0;
                margin: 2px;
                height: var(--chakra-sizes-10);
                width: var(--chakra-sizes-10);
                border-radius: 4px;
                border: 1px solid var(--chakra-colors-gray-200);
                color: var(--chakra-colors-green-500);
                font-weight: 600;
                cursor: default;
                background: none;
                &.DayPicker-Day.DayPicker-Day--bookedUp.DayPicker-Day--minNightsNotReached.DayPicker-Day--bookedUpArrivalDay.DayPicker-Day--bookedUpDepartureDay.DayPicker-Day--outside,
                &.DayPicker-Day.DayPicker-Day--bookedUp.DayPicker-Day--bookedUpArrivalDay.DayPicker-Day--outside,
                &.DayPicker-Day--bookedUp.DayPicker-Day--minNightsNotReached.DayPicker-Day--bookedUpArrivalDay.DayPicker-Day--outside,
                &.DayPicker-Day--bookedUp.DayPicker-Day--bookedUpArrivalDay.DayPicker-Day--bookedUpDepartureDay.DayPicker-Day--outside,
                &.DayPicker-Day--bookedUp.DayPicker-Day--bookedUpDepartureDay.DayPicker-Day--potentialArrivalDay.DayPicker-Day--outside,
                &.DayPicker-Day--bookedUp.DayPicker-Day--bookedUpDepartureDay.DayPicker-Day--disabled,
                &.DayPicker-Day--start.DayPicker-Day--bookedUp.DayPicker-Day--bookedUpDepartureDay.DayPicker-Day--selected.DayPicker-Day--outside,
                &.DayPicker-Day--bookedUp.DayPicker-Day--bookedUpDepartureDay.DayPicker-Day--outside,
                &.DayPicker-Day--potentialDepartureDay.DayPicker-Day--outside,
                &.DayPicker-Day--start.DayPicker-Day--selected.DayPicker-Day--outside,
                &.DayPicker-Day--end.DayPicker-Day--selected.DayPicker-Day--outside,
                &.DayPicker-Day--bookedUp.DayPicker-Day--disabled.DayPicker-Day--outside,
                &.DayPicker-Day--minNightsNotReached.DayPicker-Day--outside,
                &.DayPicker-Day--selected.DayPicker-Day--outside,
                &.DayPicker-Day--potentialDepartureDay.DayPicker-Day--disabled,
                &.DayPicker-Day--potentialArrivalDay.DayPicker-Day--outside,
                &.DayPicker-Day--disabled,
                &.DayPicker-Day--outside {
                  border: none;
                  color: var(--chakra-colors-gray-300);
                  background: none var(--chakra-colors-gray-50);
                  cursor: default;
                  font-weight: normal;
                  &:hover {
                    background: none var(--chakra-colors-gray-50);
                  }
                }
                &.DayPicker-Day--potentialArrivalDay,
                &.DayPicker-Day--potentialDepartureDay {
                  border: 1px solid var(--chakra-colors-green-500);
                  cursor: default;
                  :hover {
                    background: none var(--chakra-colors-green-50);
                  }
                }
                &.DayPicker-Day--bookedUp.DayPicker-Day--bookedUpDepartureDay.DayPicker-Day--potentialArrivalDay {
                  border: 1px solid var(--chakra-colors-green-500);
                  color: var(--chakra-colors-green-500);
                  cursor: default;
                  &:hover {
                    background: linear-gradient(
                      -135deg,
                      var(--chakra-colors-green-50) 50%,
                      var(--chakra-colors-red-400) 50%
                    );
                  }
                }
                &.DayPicker-Day--bookedUp.DayPicker-Day--bookedUpArrivalDay.DayPicker-Day--potentialDepartureDay {
                  border: 1px solid var(--chakra-colors-green-500);
                  color: var(--chakra-colors-green-500);
                  cursor: default;
                  text-decoration: inherit;
                  :hover {
                    background: linear-gradient(
                      135deg,
                      var(--chakra-colors-green-50) 50%,
                      var(--chakra-colors-red-400) 50%
                    );
                  }
                }
                &.DayPicker-Day--bookedUp.DayPicker-Day--bookedUpArrivalDay.DayPicker-Day--bookedUpDepartureDay,
                &.DayPicker-Day--bookedUp.DayPicker-Day--disabled {
                  background: none var(--chakra-colors-red-400);
                  color: white;
                  cursor: default;
                  text-decoration: inherit;
                  &:hover {
                    background: none var(--chakra-colors-red-400);
                  }
                }
                &.DayPicker-Day--bookedUp {
                  border: none;
                  text-decoration: inherit;
                  cursor: default;
                  color: var(--chakra-colors-gray-50);
                  background-color: var(--chakra-colors-red-400);
                  font-weight: normal;
                }
                &.DayPicker-Day--bookedUp.DayPicker-Day--outside {
                  border: none;
                  color: var(--chakra-colors-gray-300);
                  background-color: var(--chakra-colors-gray-50);
                  cursor: default;
                  font-weight: normal;
                }
                &.DayPicker-Day--minNightsNotReached {
                  border-color: var(--chakra-colors-gray-200);
                  cursor: default;
                  &:hover {
                    background: none;
                  }
                }
                &.DayPicker-Day--bookedUp.DayPicker-Day--minNightsNotReached.DayPicker-Day--bookedUpArrivalDay.DayPicker-Day--bookedUpDepartureDay,
                &.DayPicker-Day--bookedUp.DayPicker-Day--minNightsNotReached.DayPicker-Day--bookedUpArrivalDay {
                  border: 1px solid var(--chakra-colors-gray-200);
                  background: linear-gradient(135deg, white 50%, var(--chakra-colors-red-400) 50%);
                  color: var(--chakra-colors-green-500);
                  font-weight: 500;
                  cursor: default;
                }
                &.DayPicker-Day--bookedUp.DayPicker-Day--minNightsNotReached.DayPicker-Day--bookedUpDepartureDay,
                &.DayPicker-Day--bookedUp.DayPicker-Day--minNightsNotReached.DayPicker-Day--bookedUpArrivalDay {
                  border: 1px solid var(--chakra-colors-gray-200);
                  cursor: default;
                  text-decoration: inherit;
                  color: var(--chakra-colors-gray-100);
                }
                &.DayPicker-Day--bookedUp.DayPicker-Day--bookedUpArrivalDay {
                  border: 1px solid var(--chakra-colors-gray-200);
                  background: linear-gradient(135deg, white 50%, var(--chakra-colors-red-400) 50%);
                  color: var(--chakra-colors-gray-100);
                  font-weight: 500;
                  text-decoration: inherit;
                  cursor: default;
                  &:hover {
                    background: linear-gradient(
                      135deg,
                      white 50%,
                      var(--chakra-colors-red-400) 50%
                    );
                  }
                }
                &.DayPicker-Day--bookedUp.DayPicker-Day--bookedUpDepartureDay {
                  border: 1px solid var(--chakra-colors-gray-200);
                  background: linear-gradient(-135deg, white 50%, var(--chakra-colors-red-400) 50%);
                  color: var(--chakra-colors-gray-100);
                  font-weight: 500;
                  text-decoration: inherit;
                  cursor: default;
                  &:hover {
                    background: linear-gradient(
                      -135deg,
                      white 50%,
                      var(--chakra-colors-red-400) 50%
                    );
                  }
                }
                &.DayPicker-Day--selected {
                  background-color: var(--chakra-colors-green-200);
                  border: none;
                  color: white;
                  cursor: default;
                  &:hover {
                    background-color: var(--chakra-colors-green-200);
                  }
                }
                &.DayPicker-Day--start.DayPicker-Day--selected,
                &.DayPicker-Day--end.DayPicker-Day--selected {
                  background-color: var(--chakra-colors-green-400);
                  border: none;
                  color: white;
                }
                &.DayPicker-Day--start.DayPicker-Day--bookedUp.DayPicker-Day--bookedUpDepartureDay.DayPicker-Day--selected {
                  background: linear-gradient(
                    -135deg,
                    var(--chakra-colors-green-400) 50%,
                    var(--chakra-colors-red-400) 50%
                  );
                  &:hover {
                    cursor: default;
                  }
                }
                &.DayPicker-Day--end.DayPicker-Day--bookedUp.DayPicker-Day--bookedUpArrivalDay.DayPicker-Day--selected {
                  background: linear-gradient(
                    135deg,
                    var(--chakra-colors-green-400) 50%,
                    var(--chakra-colors-red-400) 50%
                  );
                  &:hover {
                    cursor: default;
                  }
                }
                @media (max-width: 440px) {
                  width: 34px;
                }
              }
            }
          }
        }
      }
    }
  }
`;
